import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Button, CircularProgress, Stack } from '@mui/material';
import { GameStatus } from '../../../constants/gameConstants';
import { publicNewSet, startNewSet, startPlayoff } from '../../../features/game/gameSlice';

const GameControlSecondary = ({ game, isPublic, portal }) => {
  const dispatch = useDispatch();

  const hasSets = game.gameFormat?.sets > 1 && game.status !== GameStatus.PLAYOFF;
  const currentSet = game.sets?.find((set) => set.id === game.currentSet);
  const startingNewSet = useSelector((state) => state.game.startingNewSet);
  const startingPlayoff = useSelector((state) => state.game.startingPlayoff);

  const handleNextSet = () => {
    if (portal) {
      portal.onNewSet?.();
      return;
    }

    if (!isPublic) {
      dispatch(startNewSet(game.id));
    } else {
      dispatch(publicNewSet(game.id));
    }

    //Reload Page
    window.location.reload();
  };

  const handleStartPlayoff = () => {
    if (portal) {
      portal.onStartPlayoff?.();
      return;
    }

    // if (!isPublic) {
    dispatch(startPlayoff(game.id));
    // } else {
    // dispatch(startPlayoffPublic(game.id));
    // }
    //Reload Page
    window.location.reload();
  };

  const newSetBusy = portal ? portal.busy : startingNewSet;
  const playoffBusy = portal ? portal.busy : startingPlayoff;

  return (
    <Stack alignItems={'center'}>
      {hasSets && currentSet?.isDone && game.status !== GameStatus.COMPLETE ? (
        newSetBusy ? (
          <CircularProgress color={'blue'} />
        ) : (
          <Button
            color={'blue'}
            onClick={handleNextSet}
            sx={{ mt: 2 }}
            variant="outlined"
            disabled={portal?.busy}>
            Start Next Set
          </Button>
        )
      ) : null}

      {game.status === GameStatus.PLAYOFF && !game.playoff ? (
        playoffBusy ? (
          <CircularProgress color={'warning'} />
        ) : (
          <Button
            color={'warning'}
            sx={{ mt: 2 }}
            variant="outlined"
            onClick={() => handleStartPlayoff()}
            disabled={portal?.busy}>
            Start Tiebreaker
          </Button>
        )
      ) : null}
    </Stack>
  );
};

export default GameControlSecondary;
